import React, { useState, useEffect } from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/home/Footer';

export default function Layout({ children, currentPageName }) {
  const [currentPage, setCurrentPage] = useState(currentPageName);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPageName]);

  return (
    // A flat page: the Bento layout gets its depth from tiles on the page
    // colour. The grain overlay and the two drifting colour blobs that sat here
    // fought the tile edges, and the blobs animated for as long as a page was
    // open.
    <div className="min-h-screen bg-zinc-950 text-white flex flex-col relative overflow-hidden">
      <Navbar />

      {/* Main Content */}
      <main className="flex-1">
        {children}
      </main>

      {/* Footer */}
      <Footer />

      {/* Toasts are mounted once for the whole app, in App.jsx — see there. */}
    </div>
  );
}